import React from "react";
import "./Header.css";
import { useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear saved auth info
    localStorage.removeItem("token");
    localStorage.removeItem("isAdmin");

    // Redirect to login
    navigate("/login");
  };

  return (
    <header className="header">
      <div className="logo">Garishtha Wellness</div>
      <nav className="nav-links">
        <a href="/">Home</a>
        <a href="/">About Me</a>
        <a href="/">Process</a>
        <a href="/">Contact Us</a>
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </nav>
    </header>
  );
}

export default Header;
